import React from 'react'
import moment from 'moment'
import { Box, useTheme } from '@mui/material'

function createCalendar(currentDate) {
  if (!currentDate) {
    currentDate = moment()
  } else {
    currentDate = moment(currentDate)
  }

  const first = currentDate.clone().startOf('month')
  const last = currentDate.clone().endOf('month')
  const weeksCount = Math.ceil((first.day() + last.date()) / 7)
  const calendar = Object.assign([], { currentDate, first, last })

  for (let weekNumber = 0; weekNumber < weeksCount; weekNumber++) {
    const week = []
    calendar.push(week)
    calendar.year = currentDate.year()
    calendar.month = currentDate.month()

    for (let day = 7 * weekNumber; day < 7 * (weekNumber + 1); day++) {
      const date = currentDate.clone().set('date', day + 1 - first.day())
      date.calendar = calendar
      week.push(date)
    }
  }
  return calendar
}

function CalendarDate(props) {
  const { dateToRender, dateOfMonth, events = [] } = props
  var startArray = events.map(function (e) {
    return moment(e.start).format('YYYY-MM-DD')
  })
  const today = dateToRender.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') ? 'today' : ''
  const event = startArray.find((e) => e === dateToRender.format('YYYY-MM-DD'))

  if (dateToRender.month() < dateOfMonth.month()) {
    return (
      <button disabled={true} className="date prev-month">
        {dateToRender.date()}
      </button>
    )
  }

  if (dateToRender.month() > dateOfMonth.month()) {
    return (
      <button disabled={true} className="date next-month">
        {dateToRender.date()}
      </button>
    )
  }

  return (
    <button
      className={`date in-month ${today} ${event ? 'year-event' : ''}`}
      onClick={() => props.onClick(dateToRender)}
    >
      {dateToRender.date()}
    </button>
  )
}

class Calendar extends React.Component {
  state = {
    calendar: undefined,
  }

  componentDidMount() {
    this.setState({ calendar: createCalendar(this.props.date) })
  }

  componentDidUpdate(prevProps) {
    if (this.props.date !== prevProps.date) {
      this.setState({ calendar: createCalendar(this.props.date) })
    }
  }

  render() {
    if (!this.state.calendar) {
      return null
    }

    return (
      <Box className="month" borderBottom={'1px solid gray'} pb={1}>
        <div className="month-name" style={{ marginLeft: '6px' }}>
          {this.state.calendar.currentDate.format('MMMM').toUpperCase()}
        </div>
        <Box display={'flex'} justifyContent={'space-between'} p={1} gap={1}>
          {['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((day, index) => (
            <span key={index} className="day">
              {day}
            </span>
          ))}
        </Box>
        {this.state.calendar.map((week, index) => (
          <Box key={index} display={'flex'} justifyContent={'space-between'} p={1} gap={1}>
            {week.map((date) => (
              <CalendarDate
                events={this.props.events}
                key={date.date()}
                dateToRender={date}
                dateOfMonth={this.state.calendar.currentDate}
                onClick={(date) => this.props.onDrillDown(date, 'week')}
              />
            ))}
          </Box>
        ))}
      </Box>
    )
  }
}

class Year extends React.Component {
  render() {
    const { date = new Date(), events = [], onDrillDown } = this.props

    const months = []
    for (let i = 0; i < 12; i++) {
      months.push(
        <Calendar
          key={i + 1}
          date={new Date(new Date(date).getFullYear(), i, 1)}
          events={events}
          onDrillDown={onDrillDown}
        />,
      )
    }
    return (
      <Box className="year" id="year" justifyContent={'space-between'}>
        {months.map((month) => month)}
      </Box>
    )
  }
}

Year.range = (date) => {
  return moment().startOf(date, 'year')
}

Year.navigate = (date, action, { localizer }) => {
  switch (action) {
    case 'PREV':
      return localizer.add(date, -1, 'year')

    case 'NEXT':
      return localizer.add(date, 1, 'year')

    default:
      return date
  }
}

Year.title = (date, { localizer }) => localizer.format(date, 'yearHeaderFormat')
export default Year
